import React, { Fragment } from "react"

let CodeFive = () => {

    return (
        <Fragment>
            <div className="cell code-cell">
                <div className="ace-github">
                    <div className="ace_static_highlight">
                        <div className="ace_line"><span className="ace_keyword">import</span> <span
                            className="ace_identifier">Database</span> <span className="ace_identifier">from</span>
                            <span className="ace_string">"framework/alto/data/database"</span><span
                                className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_storage ace_type">let</span> <span
                            className="ace_identifier">TodosDatabase</span> <span
                            className="ace_keyword ace_operator">=</span> <span
                            className="ace_identifier">Database</span><span
                            className="ace_punctuation ace_operator">.</span><span
                            className="ace_identifier">extend</span><span
                            className="ace_paren ace_lparen">{` ({ `}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_identifier">remote</span><span
                            className="ace_punctuation ace_operator">:</span> <span
                            className="ace_string">'https://todos.com/api/todos'</span><span
                            className="ace_punctuation ace_operator">,</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_identifier">partition</span><span
                            className="ace_punctuation ace_operator">:</span> <span
                            className="ace_paren ace_lparen">{`{`}</span><span
                            className="ace_paren ace_rparen">}</span><span
                            className="ace_punctuation ace_operator">,</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_identifier">schema</span><span
                            className="ace_punctuation ace_operator">:</span> <span
                            className="ace_paren ace_lparen">{`{`}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_indent-guide">    </span> <span
                            className="ace_identifier">id</span><span className="ace_punctuation ace_operator">:</span>
                            <span className="ace_variable ace_language"> Number</span><span
                                className="ace_punctuation ace_operator">,</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_indent-guide">    </span> <span
                            className="ace_identifier">title</span><span
                            className="ace_punctuation ace_operator">:</span>
                            <span className="ace_variable ace_language"> String</span><span
                                className="ace_punctuation ace_operator">,</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_indent-guide">    </span> <span
                            className="ace_identifier">primaryKey</span><span
                            className="ace_paren ace_lparen">(</span><span
                            className="ace_string">'id'</span><span className="ace_paren ace_rparen">)</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_paren ace_rparen">{`}`}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_paren ace_rparen">{`})`}</span><span
                            className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_keyword">export</span> <span
                            className="ace_keyword">default</span> <span className="ace_identifier">TodosDatabase</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ace_line"><br/></div>
        </Fragment>
    )

};

export default CodeFive;